import React, {Component} from 'react';
import {Utility} from 'cw-styleguide-react';
import {HashLink as Link} from 'react-router-hash-link';

class Content extends Component {
  render() {
    if (!this.props.text) {
      return '';
    }
    return this.props.text.map(function (item, index) {
      if (this.props.text[index].type === 'paragraph') {
        return <p key={index} dangerouslySetInnerHTML={{__html: this.props.text[index].value}}></p>
      }

      if (this.props.text[index].type === 'header') {
        return <h1 id={Utility.slug(this.props.text[index].value)} key={index}>{this.props.text[index].value}</h1>
      }

      if (this.props.text[index].type === 'subheader') {
        return <h3 id={Utility.slug(this.props.text[index].value)} key={index}>{this.props.text[index].value}</h3>
      }

      if (this.props.text[index].type === 'intro') {
        return <p key={index} className="style style--introduction"
                  dangerouslySetInnerHTML={{__html: this.props.text[index].value}}>

        </p>
      }

      if (this.props.text[index].type === 'list' || this.props.text[index].type === 'double_list') {
        return <ul key={index}
                   className={"style--list-circle style--list-no-bg" + (this.props.text[index].type === 'double_list' ? ' style--columns-2' : '')}>
          {this.props.text[index].list && this.props.text[index].list.map(function (item2, index2) {

            if (this.props.text[index].list[index2].item.link) {
              return <li key={index + index2}><Link
                to={this.props.text[index].list[index2].item.link}>{this.props.text[index].list[index2].item.value}</Link>
              </li>
            } else {
              return <li key={index + index2}>{this.props.text[index].list[index2].item.value}</li>
            }

          }, this)}</ul>
      }


      return '';
    }, this)
  }
}

export default Content;

